



























































































import { Vue, Component, PropSync } from 'vue-property-decorator';

@Component({})
export default class CuisinesStats extends Vue {
  @PropSync('cuisineItems', {}) cuisineItemsSync!: any;

  private loading: boolean = false;

  private headers = [

    {
      text: 'Cuisine Types',
      align: 'left',
      value: 'name',
      width: '100px',
      sortable: false,
    },
    {
      text: 'Restaurant Partners',
      align: 'center',
      value: 'partners',
      width: '100px',
      class: 'unit-tag',
      sortable: false,
    },
  ];

  public seeList: boolean = true;

  public onClickSee() {
    this.seeList = false;
  }
}
